<template>
  <div class="premission_index">
    <el-row class="elAdd">
      <button
        type="primary"
        class="add"
        icon="el-icon-plus"
        @click="dialogFormVisible = true"
        >新增</button
      >
      <!-- <div class="search_div">
        <el-input
          v-model="keywords"
          class="search_input"
          size="medium "
          placeholder="请输入搜索内容"
          prefix-icon="el-icon-search"
        />
        <el-button type="primary" @click="getAnnounceList()">搜索</el-button>
      </div> -->
    </el-row>
    <!-- 表格 -->
    <el-table
      class="premission_table"
      :data="tableDatas"
      :header-cell-style="{background: '#F9F9F9',color:'#999999'}"
      style="width: 100%"
    >
      <el-table-column type="index" label="序号" width="60" />
      <el-table-column label="用户头像" width="120">
        <!-- :preview-src-list="scope.row.image_urls" -->
        <template slot-scope="scope">
          <el-image
            style="width: 50px; height: 50px"
            class="image_box"
            :src="scope.row.header || 'https://qa.yh-med.cn:81/backend/sign/headers/1660184962612502085.jpg'"
          >
          </el-image>
        </template>
      </el-table-column>
      <el-table-column prop="userName" label="用户姓名" />
      <!-- <el-table-column prop="nickName" label="昵称" /> -->
      <el-table-column prop="loginName" label="登录名" />
      <!-- <el-table-column prop="phone" label="手机号" /> -->
      <el-table-column prop="email" label="邮箱" width="150" />
      <!-- <el-table-column prop="status" label="状态" width="160" /> -->
      <el-table-column prop="status" label="是否允许非成员参加" width="150">
        <template slot-scope="scope">
          <span>
            {{ scope.row.status == true ? "正常" : "冻结" }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="times" label="注册时间" width="160" />
      <el-table-column prop="edittimes" label="修改时间" width="160" />
      <el-table-column label="操作" fixed="right" width="160">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            @click.stop="() => edit(scope.row)"
            >编辑</el-button
          >
          <el-button
            plain
            type="danger"
            size="mini"
            @click="deleteClick(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 展示列表 -->
    <!-- 分页 -->
    <div class="pagination" >
      <el-pagination
        background=""
        layout="prev, pager, next"
        :total="totalPage"
        :current-page.sync="currentPage"
        @current-change="getMenuLinkageList(currentPage)"
      />
    </div>
    <!-- 添加弹框 -->
    <el-dialog
      top="15vh"
      title="新增"
      :visible.sync="dialogFormVisible"
      width="50%"
      :close-on-click-modal="false"
    >
      <el-form :model="form" :rules="rules" ref="form">
        <!-- <el-form-item
          prop="level"
          label="角色类型:"
          :label-width="formLabelWidth"
        >
          <el-select v-model="form.level" placeholder="请选择菜单类型">
            <el-option label="全部" value="1" />
            <el-option label="自定义" value="2" />
            <el-option label="本院" value="3" />
          </el-select>
        </el-form-item> -->
        <el-form-item
          prop="userName"
          label="用户姓名:"
          :label-width="formLabelWidth"
        >
          <el-input
            placeholder="请输入用户姓名"
            v-model="form.userName"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="avatar_id"
          label="用户头像:"
          :label-width="formLabelWidth"
        >
          <el-upload
            ref="uploadImg"
            accept="image/*"
            class="avatar-uploader"
            :action="actions"
            :show-file-list="false"
            :on-success="handleUploadSuccess"
            :on-error="handelUploadError"
            name="file"
            :data="{ token: this.token }"
          >
            <img v-if="form.header" :src="form.header" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon" />
          </el-upload>
        </el-form-item>
          <el-form-item
          prop="eSign"
          label="电子签名:"
          :label-width="formLabelWidth"
        >
          <el-upload
            ref="uploadImg"
            accept="image/*"
            class="avatar-uploader"
            :action="actions"
            :show-file-list="false"
            :on-success="handleUploadSuccesssign"
            :on-error="handelUploadError"
            name="file"
            :data="{ token: this.token }"
          >
            <img v-if="form.eSign" :src="form.eSign" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon" />
          </el-upload>
        </el-form-item>
        <el-form-item
          prop="loginName"
          label="登录名:"
          :label-width="formLabelWidth"
        >
          <el-input
            placeholder="请输入登录名"
            v-model="form.loginName"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="password"
          label="密码:"
          :label-width="formLabelWidth"
        >
          <el-input
            type="password"
            placeholder="请输入密码"
            v-model="form.password"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="phone"
          label="手机号:"
          :label-width="formLabelWidth"
        >
          <el-input
            placeholder="请输入手机号"
            v-model="form.phone"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item prop="email" label="邮箱:" :label-width="formLabelWidth">
          <el-input
            placeholder="请输入邮箱"
            v-model="form.email"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item prop="remark" label="备注:" :label-width="formLabelWidth">
          <el-input
            type="textarea"
            :row="3"
            placeholder="请输入备注"
            v-model="form.remark"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item
          prop="pid"
          label="服务名称:"
          :label-width="formLabelWidth"
        >
          <el-row>
            <el-cascader
              :options="options"
              v-model="form.pid"
              :show-all-levels="true"
              clearable
              :props="{
                expandTrigger: 'hover',
                children: 'children',
                label: 'name',
                value: 'id',
                checkStrictly: true,
                emitPath: false,
              }"
              @change="handleChange"
            >
            </el-cascader>
          </el-row>
        </el-form-item> -->
        <el-form-item
          prop="hospitalId"
          label="医院选择:"
          :label-width="formLabelWidth"
        >
          <el-select v-model="form.hospitalId" placeholder="请选择">
            <el-option
              v-for="item in permissionOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <!-- permissionOptions 医院列表 -->

        <!-- <div v-text="list"></div> -->
        <el-form-item
          prop="list"
          label="选择角色:"
          :label-width="formLabelWidth"
        >
          <el-select v-model="list" placeholder="请选择" multiple collapse-tags>
            <el-option
              v-for="item in rolelist"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item prop="status" label="状态:" :label-width="formLabelWidth">
          <el-switch
            v-model="form.status"
            active-text="正常"
            inactive-text="冻结"
            :active-value="true"
            :inactive-value="false"
          >
          </el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <button class="login_Edit" @click="dialogFormVisible = false">取 消</button>
        <button class="ok_Edit"  type="primary" @click="postForm">确 定</button>
      </div>
    </el-dialog>
    <!-- 编辑弹框 -->
    <el-dialog
      top="15vh"
      title="编辑"
      :visible.sync="dialogFormVisibleEdit"
      width="40%"
      :close-on-click-modal="false"
    >
      <el-form :model="formEdit" :rules="rules" ref="formEdit">
        <el-form-item
          prop="userName"
          label="用户姓名:"
          :label-width="formLabelWidth"
        >
          <el-input
            placeholder="请输入用户姓名"
            v-model="formEdit.userName"
            autocomplete="off"
          ></el-input>
        </el-form-item>

        <el-form-item
          prop="avatar_id"
          label="成员照片:"
          :label-width="formLabelWidth"
        >
          <el-upload
            ref="uploadImg"
            accept="image/*"
            class="avatar-uploader"
            :action="actions"
            :show-file-list="false"
            :on-success="handleUploadSuccessEdit"
            :on-error="handelUploadError"
            name="file"
            :data="{ token: this.token }"
          >
            <img
              v-if="this.formEdit.header"
              :src="this.formEdit.header"
              class="avatar"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon" />
          </el-upload>
        </el-form-item>
        <el-form-item
          prop="avatar_id"
          label="电子签名:"
          :label-width="formLabelWidth"
        >
          <el-upload
            ref="uploadImg"
            accept="image/*"
            class="avatar-uploader"
            :action="actions"
            :show-file-list="false"
            :on-success="handleUploadSuccessEditesig"
            :on-error="handelUploadError"
            name="file"
            :data="{ token: this.token }"
          >
            <img
              v-if="this.formEdit.eSign"
              :src="this.formEdit.eSign"
              class="avatar"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon" />
          </el-upload>
        </el-form-item>
        <el-form-item
          prop="loginName"
          label="登录名:"
          :label-width="formLabelWidth"
        >
          <el-input
            placeholder="请输入登录名"
            v-model="formEdit.loginName"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="passwordformEdit"
          label="密码:"
          :label-width="formLabelWidth"
        >
          <el-input
            type="password"
            placeholder="请输入密码"
            v-model="formEdit.password"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="phone"
          label="手机号:"
          :label-width="formLabelWidth"
        >
          <el-input
            placeholder="请输入手机号"
            v-model="formEdit.phone"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item prop="email" label="邮箱:" :label-width="formLabelWidth">
          <el-input
            placeholder="请输入邮箱"
            v-model="formEdit.email"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item prop="remark" label="备注:" :label-width="formLabelWidth">
          <el-input
            type="textarea"
            :row="3"
            placeholder="请输入备注"
            v-model="formEdit.remark"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="hospitalId"
          label="医院选择:"
          :label-width="formLabelWidth"
        >
          <el-select v-model="formEdit.hospitalId" placeholder="请选择">
            <el-option
              v-for="item in permissionOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <!-- <div v-text="formEditlist"></div> -->
        <el-form-item
          prop="list"
          label="选择角色:"
          :label-width="formLabelWidth"
        >
          <el-select
            v-model="formEditlist"
            placeholder="请选择"
            multiple
            collapse-tags
          >
            <el-option
              v-for="item in rolelist"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item prop="status" label="状态:" :label-width="formLabelWidth">
          <el-switch
            v-model="formEdit.status"
            active-text="正常"
            inactive-text="冻结"
            :active-value="true"
            :inactive-value="false"
          >
          </el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <button class="login_Edit" @click="dialogFormVisibleEdit = false">取 消</button>
        <button class="ok_Edit"  type="primary" @click="postFormEdit">确 定</button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import { addAnnounce, deleteAnnounce, editAnnounce, announceList } from '@/api/shop.js'

export default {
  name: "Premission",
  data() {
    return {
      actions:this.GLOBAL.BASE_URL + 'backend/manager/upload',
      token: "",
      rolelist: "",
      listlist: "",
      keysEdit: [],
      tableDatas: [],
      menuList: "",
      propd: {
        multiple: true,
        label: "name",
        value: "id",
      },
      optionss: [
        {
          value: 1,
          label: "东南",
          children: [
            {
              value: 2,
              label: "上海",
              children: [
                { value: 3, label: "普陀" },
                { value: 4, label: "黄埔" },
                { value: 5, label: "徐汇" },
              ],
            },
            {
              value: 7,
              label: "江苏",
              children: [
                { value: 8, label: "南京" },
                { value: 9, label: "苏州" },
                { value: 10, label: "无锡" },
              ],
            },
            {
              value: 12,
              label: "浙江",
              children: [
                { value: 13, label: "杭州" },
                { value: 14, label: "宁波" },
                { value: 15, label: "嘉兴" },
              ],
            },
          ],
        },
        {
          value: 17,
          label: "西北",
          children: [
            {
              value: 18,
              label: "陕西",
              children: [
                { value: 19, label: "西安" },
                { value: 20, label: "延安" },
              ],
            },
            {
              value: 21,
              label: "新疆维吾尔族自治区",
              children: [
                { value: 22, label: "乌鲁木齐" },
                { value: 23, label: "克拉玛依" },
              ],
            },
          ],
        },
      ],
      propss: {
        multiple: true,
        children: "children",
        checkStrictly: true,
        label: "name",
        value: "name",
      },
      isAllSelect: false,
      keys: [],
      defaultProps: {
        children: "children",
        label: "name",
      },
      pstlist: "",
      permissionOptions: [],
      checkList: "",
      options: "",
      keywords: "",
      totalPage: 0,
      currentPage: 1,
      tableData: [],
      dialogFormVisible: false,
      dialogFormVisibleEdit: false,
      formLabelWidth: "120px",
      list: "",
      formEditlist: [],
      form: {
        status: true,
        roles: "",
        remark: "",
        hospitalId: "",
        header: "",
        eSign: "",
        userName: "",
        loginName: "",
        password: "",
        email: "",
        phone: "",
      },
      formEdit: {
        id: "",
        status: "",
        roles: "",
        userName: "",
        loginName: "",
        password: "",
        phone: "",
        email: "",
        remark: "",
        hospitalId: "",
        pstlist: "",
        header: "",
        eSign: "",
      },
      rules: {
        // content:[{ required: true, message: "请输入公告内容", trigger: "blur" }],
        userName: [
          { required: true, message: "请输入用户姓名", trigger: "blur" },
        ],
        status: [{ required: true, message: "请选择状态", trigger: "blur" }],
        loginName: [
          { required: true, message: "请输入登录名", trigger: "blur" },
        ],
        hospitalId: [
          { required: true, message: "请选择医院", trigger: "blur" },
        ],
        // list: [
        //   { required: true, message: "请选择角色", trigger: "blur" },
        // ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        // level: [{ required: true, message: "请选择角色类型", trigger: "blur" }],
      },
    };
  },
  created() {
    this.getCdlist();
    this.getMenuLinkageList();
    this.getPermissionList();
    this.getRoleList();
    this.token = sessionStorage.getItem("token");
  },
  watch: {
    formEditlist(newVal) {
      this.formEdit.roles = newVal.join();
      console.log(this.formEdit.roles);
    },
    list(newVal) {
      this.form.roles = newVal.join();
      console.log(this.form.roles);
    },
  },
  methods: {
    time(time = +new Date()) {
      var date = new Date(time + 8 * 3600 * 1000);
      return date.toJSON().substr(0, 19).replace("T", " ").replace(/-/g, "-");
    },
    handleUploadSuccessEdit(res, file) {
      this.formEdit.header = res.data;
    },
    handleUploadSuccessEditesig(res, file) {
      this.formEdit.eSign = res.data;
    },
    handleUploadSuccess(res, file) {
      console.log(res);
      console.log(file);
      this.form.header = res.data;
      // console.error(this.imageUrl);
      // this.form.avatar_id = res.data[file.name].id;
    },
    handleUploadSuccesssign(res, file) {
      console.log(res);
      console.log(file);
      this.form.eSign = res.data;
      // console.error(this.imageUrl);
      // this.form.avatar_id = res.data[file.name].id;
    },
    handelUploadError() {
      this.$message.error("上传图片出错！");
    },
    getRoleList() {
      depot
        .post({
          url: "/backend/role/list",
          data: {},
        })
        .then((res) => {
          console.log(res);
          this.rolelist = res.data.list;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getCdlist() {
      depot
        .post({
          url: "/backend/menu/getMenus",
          data: {},
        })
        .then((res) => {
          console.log(res);
          this.tableData = res.data;
          console.log(this.tableData);
          this.menuList = JSON.parse(JSON.stringify(res.data));
          // this.options.forEach((val, index) => {
          //   val.children.forEach((valus, index) => {
          //     delete valus.children;
          //   });
          //   // delete val.children
          // });
          console.log(this.menuList);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    edit(data) {
      console.log(data);
      this.dialogFormVisibleEdit = true;
      this.formEdit = data;
      // this.formEditlist = data.roles.split(",");
      var str = "";
      data.roles.map((item) => {
        str = str + item.id + ",";
      });
      str =
        str.substring(str.length - 1) == ","
          ? str.substring(0, str.length - 1)
          : str;
      console.log(str);
      this.formEditlist = str.split(",").map(Number);
      console.log(this.formEditlist);
    },
    deleteClick(val) {
      this.$confirm("是否确认删除?", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          console.log(val);
          depot
            .post({
              url: "/backend/manager/delete",
              data: {
                id: val.id,
              },
            })
            .then((res) => {
              console.log(res);
              if (res.success == true) {
                this.$message({
                  message: "删除成功",
                  type: "success",
                });
                this.getMenuLinkageList();
                return;
              }
              this.$message({
                message: res.msg,
                type: "error",
              });
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch(() => {});
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.title.indexOf(value) !== -1;
    },
    handleChange() {
      console.log(this.value);
    },
    getMenuLinkageList(page = 1, page_num = 10) {
      // console.log(value);
      depot
        .post({
          url: "/backend/manager/list",
          data: {
            page: page,
            pageSize: page_num,
          },
        })
        .then((res) => {
          console.log(res);
          this.totalPage = (res.data.count / page_num) * 10;
          console.error('totalPage',this.totalPage)
          this.tableDatas = res.data.list;
          this.tableDatas.forEach((element) => {
            console.log(this.time(element.studyDatetime));
            element.times = this.time(element.crtTime);
            element.edittimes = this.time(element.crtTime);
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getPermissionList(value) {
      // console.log(value);
      depot
        .get({
          url: "/v1/hospital/listHospital",
          params: {
            token: sessionStorage.getItem("token"),
          },
        })
        .then((res) => {
          console.log(res.data);
          this.permissionOptions = res.data;
          console.log(this.permissionOptions);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    postForm() {
      // console.log(this.list);
      // if (this.list) {
      //   this.form.roles = this.list.map((item) => item.join(":")).join(",");
      //   console.log(this.list.map((item) => item.join(":")).join(","));
      //   console.log(this.form.roles);
      // }
      this.$refs["form"].validate((valid) => {
        if (valid) {
          depot
            .post({
              url: "/backend/manager/save",
              data: this.form,
            })
            .then((res) => {
              console.log(res);
              if (res.success == true) {
                this.$message({
                  message: "添加成功",
                  type: "success",
                });
                this.dialogFormVisible = false;
                this.getMenuLinkageList();
                return;
              }
              this.$message({
                message: res.msg,
                type: "error",
              });
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    },
    handleDelete(row) {
      this.$confirm("是否确认删除?", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteAnnounce({
            id: row.id,
          })
            .then((res) => {
              this.getAnnounceList(this.currentPage);
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch(() => {});
    },
    handleEdit(row) {
      let {
        id,
        userName,
        loginName,
        status,
        password,
        phone,
        email,
        remark,
        hospitalId,
      } = row;
      this.formEdit.id = id;
      this.formEdit.userName = userName;
      this.formEdit.loginName = loginName;
      this.formEdit.password = password;
      this.formEdit.phone = phone;
      this.formEdit.email = email;
      this.formEdit.remark = remark;
      this.formEdit.hospitalId = hospitalId;
      this.formEdit.status = status;
      this.dialogFormVisibleEdit = true;
    },
    postFormEdit() {
      //  console.log(this.formEditlist);
      //   this.formEdit.roles = this.formEditlist.map((item) => item.join(":")).join(",");
      //   console.log(this.formEditlist.map((item) => item.join(":")).join(","));
      //   console.log(this.formEdit.roles);
      this.$refs["formEdit"].validate((valid) => {
        if (valid) {
          depot
            .post({
              url: "/backend/manager/update",
              data: this.formEdit,
            })
            .then((res) => {
              console.log(res);
              if (res.success == true) {
                this.$message({
                  message: "修改成功",
                  type: "success",
                });
                this.dialogFormVisibleEdit = false;
                this.getMenuLinkageList();
                return;
              }
              this.$message({
                message: "修改失败",
                type: "error",
              });
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    },
  },
};
</script>

<style scoped>
.premission_index {
  padding: 10px;
  background: #fff;
  margin-top: 10px;
}
.search_div {
  float: right;
}
.search_input {
  width: 220px;
}
.premission_table {
  margin-top: 10px;
}
.pagination_box {
}
.pagination {
  padding: 0 300px;
  margin-top: 20px;
  text-align: center;
}
.elAdd {
  margin-bottom: 10px;
}
.avatar {
  width: 100px;
  height: 100%;
}
/deep/.image_box .el-image__inner {
  object-fit: cover !important;
}
/deep/.pagination .btn-prev {
  display: none !important;
}
/deep/.pagination .btn-next {
  display: none !important;
}

/deep/.pagination .el-pager li:hover {
  color: #000 !important;
}
/deep/.pagination .el-pager .active {
  background: #009b43 !important;
  color: #fff !important;
}
.add {
  position: fixed;
  right: 20px;
  top:88px;
  font-size: 16px;
  width: 120px;
  font-weight: 400;
  height: 40px;
  background: #009b43;
  border: none;
  color: #fff;
    -o-transition: all .4s ease-in-out;
    -webkit-transition: all .4s ease-in-out;
    transition: all .4s ease-in-out;
    border-radius: 3px;
}

.add:hover {
  border-radius: 3px;
  background-image: linear-gradient(to right, #0ba360, #3cba92, #30dd8a, #2bb673);
  box-shadow: 0 4px 15px 0 rgba(23, 168, 108, 0.75);
   background-position: 100% 0;
    -o-transition: all .4s ease-in-out;
    -webkit-transition: all .4s ease-in-out;
    transition: all .4s ease-in-out;
}
.ok_Edit {
  cursor: pointer;
  width: 120px;
  height: 40px;
  background: #009B43;
  font-size: 14px;
  font-weight: 500;
  border-radius: 4px;
  border: none;
  margin-left: 30px;
  color: #fff;
}
.login_Edit {
  cursor: pointer;
  width: 120px;
  height: 40px;
  font-size: 14px;
  font-weight: 500;
  background: #EEEEEE;
  border-radius: 4px;
  border: none;
  color: #999999;
}
</style>




// WEBPACK FOOTER //
// src/views/user/index.vue